import {
  Alert,
  AlertTitle,
  Grid,
  Snackbar,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import Button from "@mui/material/Button";
import { Box } from "@mui/system";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux/es/exports";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomDateField from "../CustomComponents/CustomDateField";
import CustomDropDown from "../CustomComponents/CustomDropDown";
import CustomTextField from "../CustomComponents/CustomTextField";
import StlapFooter from "../CustomComponents/StlapFooter";
import NachFilter from "./NachFilter";
import { NachFilterReducerAction } from "../Store/NachFilterReducer";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { NachAction } from "../Store/NachStore";
import axios from "axios";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CryptoJS from "crypto-js";

import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";

const NachMandate = () => {
  //Importing Hooks
  const dispatch = useDispatch();

  //Selectors from redux store
  //const filterData = useSelector((state) => state.nachFilter.filterData);
  const showMandate = useSelector((state) => state.nachFilter.showMandate);
  const FilteredData = useSelector((state) => state.nachFilter.data);
  const touchHandlers = useSelector((state) => state.nach.touchHandler);
  //Handling update button disabled
  const updateButtonDisabled = useSelector(
    (state) => state.nachFilter.disabledUpdateButton
  );

  // Dialog msg content.
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogTitleMessage, setDialogTitleMessage] = useState("");
  const [dialogConfirmMode, setDialogConfirmMode] = useState(false);
  const [activeDialogTitle, setActiveDialog] = useState();

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertTitleMsg, setAlertTitleMsg] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  const deviceModeValue = useMediaQuery("(max-width:1200px)");
  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);
  }, []);

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
    setAlertTitleMsg("");
  };

  useEffect(() => {
    if (FilteredData.editLock) {
      setShowBtn(false);
    } else {
      if (FilteredData.status.toUpperCase() === "New".toUpperCase()) {
        setShowBtn(true);
        setBtnName("Save");
        setMandateStartDateVisibilityFlag(true);
      } else if (
        FilteredData.status.toUpperCase() === "Registered".toUpperCase() ||
        FilteredData.status.toUpperCase() === "on_hold".toUpperCase() ||
        FilteredData.status.toUpperCase() === "inward".toUpperCase()
      ) {
        setShowBtn(true);
        setBtnName("Update");
        setMandateStartDateVisibilityFlag(false);
      } else if (
        FilteredData.status.toUpperCase() === "Verified".toUpperCase() ||
        FilteredData.status.toUpperCase() === "activated".toUpperCase() ||
        FilteredData.status.toUpperCase() === "deactivated".toUpperCase() ||
        FilteredData.status.toUpperCase() === "rejected".toUpperCase()
      ) {
        setShowBtn(false);
        setMandateStartDateVisibilityFlag(false);
      }
    }
  }, [FilteredData]);
  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [activeDialogTitle]);
  // useEffect(() => {
  //   const data = CryptoJS.AES.encrypt(
  //     JSON.stringify(true),
  //     "XkhZG4fW2t2W"
  //   ).toString();
  //   // sessionStorage.setItem("check", data);
  //   const datas = JSON.parse(
  //     CryptoJS.AES.decrypt(
  //       `${
  //         sessionStorage.getItem("check") !== null
  //           ? sessionStorage.getItem("check")
  //           : CryptoJS.AES.encrypt(
  //               JSON.stringify(false),
  //               "XkhZG4fW2t2W"
  //             ).toString()
  //       } `,
  //       "XkhZG4fW2t2W"
  //     ).toString(CryptoJS.enc.Utf8)
  //   );
  //   console.log("Dept Data : " + datas);
  // }, []);
  //Button updation
  const [btnName, setBtnName] = useState("");
  //Button state to show or Hide
  const [showBtn, setShowBtn] = useState(true);
  //Maintaining Mandate Reference Number
  const [mandateReferenceNumber, setMandateReferenceNumber] = useState("");
  //Maintainig State for Dialog while submitting the application
  const [mandateStartDateVisibilityFlag, setMandateStartDateVisibilityFlag] =
    useState();

  const [open, setOpen] = useState(false);
  const [informationDialogOpen, setInformationDialogOpen] = useState(false);
  const [informationDialogMessage, setinformationDialogMessage] = useState("");
  //OK or Yes Button Handler
  const [okYesButton, setOkYesButton] = useState("");

  const informationDialogClose = () => {
    setInformationDialogOpen(false);
    resetValues();
  };
  //Field Validation
  const sponserBankIsValid =
    FilteredData.sponsorBank !== "" &&
    FilteredData.sponsorBank !== null &&
    FilteredData.sponsorBank !== undefined;
  const frequencyIsValid =
    FilteredData.frequency !== "" &&
    FilteredData.frequency !== null &&
    FilteredData.frequency !== undefined;
  const debitTypeIsValid =
    FilteredData.debitType !== "" &&
    FilteredData.debitType !== null &&
    FilteredData.debitType !== undefined;
  const FBDIsValid =
    FilteredData.fbd !== "" &&
    FilteredData.fbd !== null &&
    FilteredData.fbd !== undefined &&
    new Date(FilteredData.fbd).toDateString() !== "Invalid Date" &&
    new Date(FilteredData.fbd).toLocaleDateString().slice(-4) >= "1970" &&
    new Date(FilteredData.fbd).toLocaleDateString().slice(-4) <= "2055";

  var today = new Date();
  var givenYear = new Date(FilteredData.mandateStartDate).getFullYear();
  var givenMonth = new Date(FilteredData.mandateStartDate).getMonth() + 1; // Adding 1 because month is zero-based
  var givenDay = new Date(FilteredData.mandateStartDate).getDate();

  // Extract year, month, and day values from today's date
  var todayYear = today.getFullYear();
  var todayMonth = today.getMonth() + 1;
  var todayDay = today.getDate();

  let mandateStartDateValidationFlag;
  if (givenYear > todayYear) {
    mandateStartDateValidationFlag = true;
  } else if (givenYear === todayYear && givenMonth > todayMonth) {
    mandateStartDateValidationFlag = true;
  } else if (
    givenYear === todayYear &&
    givenMonth === todayMonth &&
    givenDay >= todayDay
  ) {
    mandateStartDateValidationFlag = true;
  } else {
    mandateStartDateValidationFlag = false;
  }
  const mandateStartDateIsValid = mandateStartDateVisibilityFlag
    ? FilteredData.mandateStartDate !== "" &&
      FilteredData.mandateStartDate !== null &&
      FilteredData.mandateStartDate !== undefined &&
      new Date(FilteredData.mandateStartDate).toDateString() !==
        "Invalid Date" &&
      new Date(FilteredData.mandateStartDate).toLocaleDateString().slice(-4) >=
        "1970" &&
      new Date(FilteredData.mandateStartDate).toLocaleDateString().slice(-4) <=
        "2055" &&
      mandateStartDateValidationFlag
    : true;
  // const firstNachBillingDateIsValid =
  //   FilteredData.firstNachBillingDate !== "" &&
  //   FilteredData.firstNachBillingDate !== null &&
  //   FilteredData.firstNachBillingDate !== undefined;
  const mandateValidityIsValid =
    FilteredData.mandateValidity !== "" &&
    FilteredData.mandateValidity !== null &&
    FilteredData.mandateValidity !== undefined;

  // nach amount & mandate amount validation.
  const nachAmtIsValid =
    FilteredData.nachAmt !== "" &&
    FilteredData.nachAmt !== "0" &&
    FilteredData.nachAmt !== 0 &&
    FilteredData.nachAmt > 0 &&
    FilteredData.nachAmt !== null &&
    FilteredData.nachAmt !== undefined &&
    FilteredData.nachAmt <= 999999999 &&
    !FilteredData.nachAmt.toString().includes(".") &&
    !(FilteredData.nachAmt - Math.floor(FilteredData.nachAmt) !== 0);

  const mandateAmtIsValid =
    FilteredData.mandateAmt !== "" &&
    FilteredData.mandateAmt !== "0" &&
    FilteredData.mandateAmt !== 0 &&
    FilteredData.mandateAmt !== null &&
    FilteredData.mandateAmt !== undefined;

  //Has Error
  const SponserBankHasError = touchHandlers.sponserBank && !sponserBankIsValid;
  const frequencyHasError = touchHandlers.frequency && !frequencyIsValid;
  const debitTypeHasError = touchHandlers.debitType && !debitTypeIsValid;
  const mandateValidityHasError =
    touchHandlers.mandateValidity && !mandateValidityIsValid;
  const FBDHasError = touchHandlers.fbd && !FBDIsValid;
  const mandateStartDateHasError =
    touchHandlers.mandateStartDate && !mandateStartDateIsValid;
  // const firstNachBillingDateHasError =
  //   touchHandlers.firstNachBillingDate && !firstNachBillingDateIsValid;

  const nachAmtHasError = touchHandlers.nachAmt && !nachAmtIsValid;
  const mandateAmtHasError = touchHandlers.mandateAmt && !mandateAmtIsValid;

  //Handling Dailog method
  const handleClickOpen = () => {
    setActiveDialog("Confirmation");
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  //shortcut key
  const saveRef = useRef(null);
  const cancelRef = useRef(null);
  const yesRef = useRef(null);
  const okRef = useRef(null);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "nachMandate",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.

      if (activeDialogTitle === "Confirmation") {
        handleClose();
      }
      if (activeDialogTitle === "Information") {
        informationDialogClose();
      }
    }
    let refList = { cancelRef: cancelRef };
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.ctrlKey) {
      switch (charCode) {
        case "s": //save or update
          saveRef.current && saveRef.current.click();
          break;
        case "y": //yes on confirmation dialog
          yesRef.current && yesRef.current.click();
          break;
        case "k":
          okRef.current && okRef.current.click();
          break;
        case "q":
          dispatch(
            CommonShortCutAction.getShortCutValue({
              event: event,
              refs: refList,
            })
          );
          break;
      }
    }
  };

  const resetValues = () => {
    dispatch(NachFilterReducerAction.updateShowMandate(false));
    dispatch(NachFilterReducerAction.updateBranchTouchHandler(false));
    dispatch(NachFilterReducerAction.updateApplicationTouchHandler(false));
    dispatch(NachFilterReducerAction.resetFilterValues());
    dispatch(NachFilterReducerAction.resetValues());
    dispatch(NachAction.setResetTouchHandler(false));
    dispatch(NachFilterReducerAction.updateBankAccountNumTouchHandler(false));
  };

  const handleDialogClose = () => {
    handleClose();
    setTimeout(() => {
      if (!dialogConfirmMode) {
        resetValues();
      }
    }, 1000);
  };
  const handleOk = () => {
    setOpen(false);
    SendData();
  };

  const createBankDetailsVo = (row, bankrecord) => {
    row.accountType = bankrecord.accountType;
    row.bankAccHolderName = bankrecord.bankAccHolderName;
    row.bankAccountNum = bankrecord.bankAccountNum;
    row.bankName = bankrecord.bankName;
    row.branchName = bankrecord.mandateBranch;
    row.ifscCode = bankrecord.ifscCode;
    row.micr = bankrecord.micr;
  };

  const loadFrequencyAndDebitType = async (nachData) => {
    //convert the nachData.
    const nachrecord = { ...nachData };
    // every record will have different bankaccount number in real time.
    // set the bank values to the row.
    const bankrecord = nachrecord.nachBankVoList[0];
    createBankDetailsVo(nachrecord, bankrecord);

    // const frequencyResponse = await axios.get("/frequency/getAll");
    // const debitTypeResponse = await axios.get("/debit/getAll");
    // const mandateValidityResponse = await axios.get("/mandateValidity/getAll");
    const nachLovValues = await axios.post("/lovMaster/getLovValues", {
      moduleId: "MD002",
    });
    const frequencyTypeData = nachLovValues.data["Frequency"].map((type) => {
      return {
        key: type.lovOrder,
        value: type.lovValues,
        text: type.lovValues,
      };
    });
    const debitTypeData = nachLovValues.data["Debit Type"].map((type) => {
      return {
        key: type.lovOrder,
        value: type.lovValues,
        text: type.lovValues,
      };
    });
    const mandateValidityData = nachLovValues.data["Mandate Validity"].map(
      (type) => {
        return {
          key: type.lovOrder,
          value: type.lovValues,
          text: type.lovValues,
        };
      }
    );
    dispatch(
      NachFilterReducerAction.updateFrequencyTypeArray(frequencyTypeData)
    );
    dispatch(NachFilterReducerAction.updateDebitTypeArray(debitTypeData));
    dispatch(
      NachFilterReducerAction.updateMandateValidityArray(mandateValidityData)
    );
    nachrecord.frequencyTypeArray = frequencyTypeData;
    nachrecord.debitTypeArray = debitTypeData;
    nachrecord.mandateValidityArray = mandateValidityData;
    dispatch(NachFilterReducerAction.updateValues(nachrecord));
    dispatch(NachFilterReducerAction.updateShowMandate(true));
  };

  //on Save
  const SendData = async () => {
    let data = { ...FilteredData };
    data.firstNachBillingDate = data.fbd;
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchWithCode = branchWithCodes.filter(
      (branch) => branch.code === data.applicationBranchCode
    );
    data.applicationBranchCode = branchWithCode[0].code;
    try {
      const response = await axios.post("/nach/register", data);
      if (response.status === 200) {
        setMandateReferenceNumber(response.data.mandateNum);
        if (FilteredData.status.toUpperCase() === "NEW") {
          dispatch(
            NachFilterReducerAction.updateMandateNum(response.data.mandateNum)
          );
          setActiveDialog("Information");
          setinformationDialogMessage(`NACH Mandate is Created Successfully.`);

          setInformationDialogOpen(true);
          // setMessage("NACH Registration Successful");
          // setAlertType("success");
          //openAlertHandler();
          if (response.data.status.toUpperCase() === "on_hold".toUpperCase()) {
            setAlertType("warning");
            setMessage(
              "NACH Registration has different FBD other than Disbursement Billing Date."
            );
            openAlertHandler();
          }
          await loadFrequencyAndDebitType(response.data);
        } else {
          // setMessage("NACH UB is Updated Successfully");
          // setAlertType("success");
          setActiveDialog("Information");

          setinformationDialogMessage(`NACH Mandate is Updated Successfully.`);
          setInformationDialogOpen(true);
          if (response.data.status.toUpperCase() === "on_hold".toUpperCase()) {
            setAlertType("warning");
            setMessage(
              "NACH Registration has different FBD other than Disbursement Billing Date."
            );
            openAlertHandler();
          }

          await loadFrequencyAndDebitType(response.data);

          // setTimeout(() => {
          //   resetValues();
          // }, 1000);
        }
      } else if (response.status === 206) {
        setAlertType("error");
        const errorResponse = response.data;
        setAlertTitleMsg(
          `${errorResponse.nachAmtError} ${
            errorResponse.nachBalanceAmt === "0"
              ? ""
              : parseFloat(errorResponse.nachBalanceAmt).toLocaleString("en-IN")
          } `
        );
        setMessage(errorResponse.mandateAmtError);
        openAlertHandler();
      }
    } catch {
      setAlertType("error");
      setMessage(
        FilteredData.status.toUpperCase() === "NEW"
          ? "NACH Registration Failed"
          : "NACH Registration Updation Failed"
      );
      openAlertHandler();
    }
  };
  const nachAmountOnChangeHandler = (value) => {
    dispatch(NachFilterReducerAction.updateDisablesState(false));
    dispatch(
      NachFilterReducerAction.updateNachAmt(
        value ? value.replaceAll(",", "") : 0
      )
    );
    let data = value.replaceAll(",", "");
    if (
      data !== "" &&
      data !== "0" &&
      data !== 0 &&
      data > 0 &&
      !data.toString().includes(".") &&
      data !== null &&
      data !== undefined &&
      data <= 999999999 &&
      !(data - Math.floor(data) !== 0)
    ) {
      dispatch(
        NachFilterReducerAction.updateMandateAmt(
          value ? String(parseFloat(value.replaceAll(",", "")) * 2) : 0
        )
      );
    } else {
      dispatch(NachFilterReducerAction.updateMandateAmt(0));
    }
  };
  // Save Button Handler
  const onSaveButtonClickHandler = () => {
    dispatch(NachAction.setResetTouchHandler(true));
    if (
      sponserBankIsValid &&
      frequencyIsValid &&
      debitTypeIsValid &&
      // FBDIsValid &&
      // mandateStartDateIsValid &&
      // firstNachBillingDateIsValid &&
      mandateValidityIsValid &&
      nachAmtIsValid &&
      mandateAmtIsValid
    ) {
      setActiveDialog("Confirmation");
      const msg =
        FilteredData.status.toUpperCase() === "New".toUpperCase()
          ? "Confirmation for NACH Mandate Create ?"
          : "Confirmation for NACH Mandate Update ?";
      setDialogTitleMessage("Confirmation");
      setDialogMessage(msg);
      handleClickOpen();
    } else {
      return;
    }
  };
  return (
    <>
      <Box style={{ minHeight: "calc(100vh - 120px)" }}>
        <NachFilter />
        {showMandate && (
          <Box sx={{ marginTop: "8px" }}>
            <AccordianContainer
              id="accord"
              title="NACH Registration"
              initialOpen={true}
              sx={{ margin: "8px !important" }}
            >
              <>
                <Box sx={{ marginTop: "-1%" }}>
                  <Box>
                    <Grid container rowSpacing={0} columnSpacing={1}>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomAutoComplete
                          variant="standard"
                          type="text"
                          placeholder="Select NACH Sponsor Bank"
                          label="NACH Sponsor Bank"
                          required={true}
                          autoCompleteValues={FilteredData.sponserBankArray}
                          value={FilteredData.sponsorBank}
                          disabled={!showBtn}
                          onChange={(e, value) => {
                            dispatch(
                              NachFilterReducerAction.updateDisablesState(false)
                            );
                            dispatch(
                              NachFilterReducerAction.updateSponserBank(value)
                            );
                          }}
                          onBlur={() => {
                            dispatch(
                              NachAction.updateSponserBankTouchHandler(true)
                            );
                          }}
                        />
                        {SponserBankHasError && (
                          <p className="error">
                            Please Select NACH Sponsor Bank
                          </p>
                        )}
                        {/* <CustomTextField
                      type="Nach Sponser Bank"
                      label="Nach Sponser Bank"
                      variant="standard"
                      disabled={true}
                      value={FilteredData.sponsorBank}
                    ></CustomTextField> */}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="IFSC"
                          label="IFSC"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.ifscCode}
                        ></CustomTextField>
                      </Grid>
                      {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="MICR"
                          label="MICR"
                          variant="standard"
                          disabled={!showBtn}
                          value={FilteredData.micr}
                        ></CustomTextField>
                      </Grid> */}
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Bank Name"
                          label="Bank Name"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.bankName}
                        ></CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Branch Name"
                          label="Branch Name"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.mandateBranch}
                        ></CustomTextField>
                      </Grid>
                      {/* <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Drawee Place"
                          label="Drawee Place"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.draweePlace}
                        ></CustomTextField>
                      </Grid> */}
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Bank Account Number"
                          label="Bank Account Number"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.bankAccountNum}
                        ></CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Account Holder Name"
                          label="Account Holder Name"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.bankAccHolderName.toUpperCase()}
                        ></CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Account Type"
                          label="Account Type"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.accountType}
                        ></CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Mandate Number"
                          label="Mandate Number"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.mandateNum}
                        ></CustomTextField>
                      </Grid>

                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="NACH Amount"
                          label="NACH Amount (₹)"
                          variant="standard"
                          required={true}
                          disabled={!showBtn}
                          value={
                            FilteredData.nachAmt === "0"
                              ? 0
                              : FilteredData.nachAmt !== "" &&
                                FilteredData.nachAmt !== "0" &&
                                FilteredData.nachAmt !== 0 &&
                                FilteredData.nachAmt > 0 &&
                                FilteredData.nachAmt !== null &&
                                FilteredData.nachAmt !== undefined &&
                                FilteredData.nachAmt <= 999999999 &&
                                !(
                                  FilteredData.nachAmt -
                                    Math.floor(FilteredData.nachAmt) !==
                                  0
                                ) &&
                                !FilteredData.nachAmt.toString().includes(".")
                              ? parseFloat(FilteredData.nachAmt).toLocaleString(
                                  "en-IN"
                                )
                              : FilteredData.nachAmt
                          }
                          onChange={(event, value) => {
                            if (
                              !(
                                event.target.value.includes("e") ||
                                event.target.value.includes("E")
                              )
                            ) {
                              nachAmountOnChangeHandler(event.target.value);
                            } else {
                              nachAmountOnChangeHandler(0);
                            }
                          }}
                          onBlur={() => {
                            dispatch(
                              NachAction.updateNachAmtTouchHandler(true)
                            );
                          }}
                        ></CustomTextField>
                        {nachAmtHasError && (
                          <p className="error">
                            Please Enter Valid NACH Amount
                          </p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Mandate Amount"
                          label="Mandate Amount (₹)"
                          variant="standard"
                          value={
                            FilteredData.mandateAmt === "0"
                              ? 0
                              : parseInt(
                                  FilteredData.mandateAmt
                                ).toLocaleString("en-IN")
                          }
                          onChange={(event, value) => {
                            dispatch(
                              NachFilterReducerAction.updateMandateAmt(
                                event.target.value
                                  ? event.target.value.replaceAll(",", "")
                                  : 0
                              )
                            );
                          }}
                          disabled={true}
                        ></CustomTextField>
                        {/* {mandateAmtHasError && (
                        <p className="error">Mandate Amount is Invalid</p>
                      )} */}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomDropDown
                          type="Frequency"
                          label="Frequency"
                          variant="standard"
                          value={FilteredData.frequency}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "up",
                              horizontal: "right",
                            },
                            getContentAnchorEl: null,
                          }}
                          disabled={!showBtn}
                          required={true}
                          dropDownValue={FilteredData.frequencyTypeArray}
                          onBlur={() => {
                            dispatch(
                              NachAction.updateFrequencyTouchHandler(true)
                            );
                          }}
                          onChange={(e) => {
                            dispatch(
                              NachFilterReducerAction.updateFrequency(
                                e.target.value
                              )
                            );
                            dispatch(
                              NachFilterReducerAction.updateDisablesState(false)
                            );
                          }}
                        />
                        {frequencyHasError && (
                          <p className="error">Please Select Frequency</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomDropDown
                          type="Debit"
                          label="Debit Type"
                          variant="standard"
                          disabled={!showBtn}
                          required={true}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "up",
                              horizontal: "right",
                            },
                            getContentAnchorEl: null,
                          }}
                          value={FilteredData.debitType}
                          dropDownValue={FilteredData.debitTypeArray}
                          onBlur={() => {
                            dispatch(
                              NachAction.updateDebitTypeTouchHandler(true)
                            );
                          }}
                          onChange={(e) => {
                            dispatch(
                              NachFilterReducerAction.updateDisablesState(false)
                            );
                            dispatch(
                              NachFilterReducerAction.updateDebitType(
                                e.target.value
                              )
                            );
                          }}
                        />
                        {debitTypeHasError && (
                          <p className="error">Please Select Debit Type</p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomDateField
                          type="FBD"
                          label="FBD"
                          variant="standard"
                          minDate={"1970/01/01"}
                          maxDate={"2055/12/31"}
                          // disabled={!showBtn}
                          disabled={true}
                          value={FilteredData.fbd}
                          // onBlur={() => {
                          //   dispatch(NachAction.updateFbdTouchHandler(true));
                          // }}
                          // onChange={(value) => {
                          //   dispatch(
                          //     NachFilterReducerAction.updateDisablesState(false)
                          //   );
                          //   dispatch(NachFilterReducerAction.updateFBD(value));
                          // }}
                        ></CustomDateField>
                        {/* {FBDHasError && (
                          <p className="error">Please Enter Valid FBD</p>
                        )} */}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomDateField
                          label="Mandate Start Date"
                          variant="standard"
                          // disabled={!mandateStartDateVisibilityFlag}
                          disabled={true}
                          // required={true}
                          disablePast={true}
                          value={FilteredData.mandateStartDate}
                          // onBlur={() => {
                          //   dispatch(
                          //     NachAction.updateMandateStartDateTouchHandler(
                          //       true
                          //     )
                          //   );
                          // }}
                          // onChange={(value) => {
                          //   dispatch(
                          //     NachFilterReducerAction.updateDisablesState(false)
                          //   );
                          //   dispatch(
                          //     NachFilterReducerAction.updateMandateStartDate(
                          //       value
                          //     )
                          //   );
                          // }}
                        ></CustomDateField>
                        {/* {mandateStartDateHasError && (
                          <p className="error">
                            Please Enter Valid Mandate Start Date
                          </p>
                        )} */}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomDateField
                          label="First NACH Billing Date"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.fbd}
                          // onBlur={() => {
                          //   dispatch(
                          //     NachAction.updateFirstNachBillingDateTouchHandler(
                          //       true
                          //     )
                          //   );
                          // }}
                          // onChange={(value) => {
                          //   dispatch(
                          //     NachFilterReducerAction.updateFirstNachBillingDate(
                          //       value
                          //     )
                          //   );
                          // }}
                        ></CustomDateField>
                        {/* {firstNachBillingDateHasError && (
                          <p className="error">
                            Please Select First Naching Billing Date
                          </p>
                        )} */}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Maximum Amount"
                          label="Maximum Amount (₹)"
                          variant="standard"
                          value={parseInt(
                            FilteredData.maximumAmt
                          ).toLocaleString("en-IN")}
                          disabled={true}
                        ></CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        {/* <CustomDateField
                      type="Mandate Validity"
                      label="Mandate Validity"
                      variant="standard"
                      disabled={true}
                      value={FilteredData.mandateValidity}
                    ></CustomDateField> */}
                        <CustomDropDown
                          type="MandateValidity"
                          label="Mandate Validity"
                          variant="standard"
                          disabled={!showBtn}
                          required={true}
                          value={FilteredData.mandateValidity}
                          dropDownValue={FilteredData.mandateValidityArray}
                          MenuProps={{
                            anchorOrigin: {
                              vertical: "up",
                              horizontal: "right",
                            },
                            getContentAnchorEl: null,
                          }}
                          onBlur={() => {
                            dispatch(
                              NachAction.updateMandateValidityTouchHandler(true)
                            );
                          }}
                          onChange={(e) => {
                            dispatch(
                              NachFilterReducerAction.updateDisablesState(false)
                            );
                            dispatch(
                              NachFilterReducerAction.updateMandateValidity(
                                e.target.value
                              )
                            );
                          }}
                        />
                        {mandateValidityHasError && (
                          <p className="error">
                            Please Select Mandate Validity
                          </p>
                        )}
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomDateField
                          type="Mandate End Date"
                          label="Mandate End Date"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.mandateEndDate}
                        ></CustomDateField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Customer Mobile Number"
                          label="Customer Mobile Number"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.customerMobileNum}
                        ></CustomTextField>
                      </Grid>
                      <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                        <CustomTextField
                          type="Customer Email ID"
                          label="Customer Email ID"
                          variant="standard"
                          disabled={true}
                          value={FilteredData.customerEmailId}
                        ></CustomTextField>
                      </Grid>
                    </Grid>
                  </Box>
                  {showBtn && (
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "8px",
                        marginBottom: "4px",
                      }}
                    >
                      <Tooltip title="Ctrl+S" placement="top">
                        <Button
                          sx={{
                            color: "white",
                            backgroundColor: "#004a92",
                            fontWeight: "bold",
                            height: "2rem",
                          }}
                          onMouseOver={({ target }) => {
                            target.style.backgroundColor = "#004a92";
                            target.style.color = "white";
                          }}
                          variant="contained"
                          onClick={onSaveButtonClickHandler}
                          disabled={updateButtonDisabled}
                          ref={saveRef}
                        >
                          {btnName}
                        </Button>
                      </Tooltip>
                    </Box>
                  )}
                </Box>
              </>
              <Dialog
                open={open}
                // onClose={handleDialogClose}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle>{dialogTitleMessage}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description">
                    {dialogMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Tooltip title="Ctrl+Q" placement="top">
                    <Button onClick={handleClose} ref={cancelRef}>
                      Cancel
                    </Button>
                  </Tooltip>
                  <Tooltip title="Ctrl+Y" placement="top">
                    <Button onClick={handleOk} ref={yesRef}>
                      Yes
                    </Button>
                  </Tooltip>
                </DialogActions>
              </Dialog>
              <Dialog
                open={informationDialogOpen}
                // onClose={handleDialogClose}
                aria-describedby="alert-dialog-slide-description"
              >
                <DialogTitle>Information</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-slide-description">
                    {informationDialogMessage}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Tooltip title="Ctrl+K" placement="top">
                    <Button onClick={informationDialogClose} ref={okRef}>
                      Ok
                    </Button>
                  </Tooltip>
                </DialogActions>
              </Dialog>
            </AccordianContainer>
          </Box>
        )}

        <Snackbar
          open={alert}
          autoHideDuration={6000}
          anchorOrigin={{ vertical, horizontal }}
          onClose={closeAlertHandler}
        >
          <Alert
            onClose={closeAlertHandler}
            severity={alertType}
            variant="filled"
            sx={{ width: "100%" }}
          >
            <AlertTitle>{alertTitleMsg}</AlertTitle>
            {message}
          </Alert>
        </Snackbar>
      </Box>

      <StlapFooter />
    </>
  );
};

export default NachMandate;
